// extracted by mini-css-extract-plugin
export default {"container":"mSh46g","heading":"bzYqPc","instagram":"hXSNlF","accessibilityThemeContainer":"ykig24"};